import { useRef, useState } from "react";
import JornadaAnioFilter from "../../components/Filters/JornadaAnioFilter";
import { Button } from "react-bootstrap";
import asistenciaService from "../../services/asistenciaService";
import moment from "moment";
import HeaderActa from "../../components/headerActas";
import utils from '../../utils/generalFunctions';
import { toast } from 'react-toastify';
import Loading from "../../components/Loading";
import FooterActa from "../../components/FooterActa";
import types from "../../services/types";
import EstudianteFilter from "../../components/Filters/EstudianteFilter";

const RepoAsistenciaAnualEstudiante = () => {
    const filteReference = useRef(null);
    const initData = {
        studentId: "0",
        schoolYearId: "0",
        journeyId: "0",
    };
    const [formData, setFormData] = useState(initData);
    const [selectedStudent, setSelectedStudent] = useState(null);
    const [asistencias, setAsistencias] = useState([]);
    const [ausenciasPorFecha, setAusenciasPorFecha] = useState([]);
    const [ausenciasPorAsignatura, setAusenciasPorAsignatura] = useState([]);
    const [datosBusqueda, setDatosBusqueda] = useState({});
    const [showLoading, setShowLoading] = useState(false);
    const [showResult, setShowResult] = useState(false);

    const showMensajeError = (mensaje) => {
        toast.error(mensaje, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    };

    const updateForm = (data) => {
        setFormData(prevState => ({
            ...prevState,
            ...data
        }));
    };

    // Al seleccionar el estudiante, precarga jornada y año escolar (igual que en
    // el consolidado diario) y guarda el resto de la información del estudiante
    // (curso, grado) que la búsqueda necesita pero que este reporte no muestra
    // como filtro.
    const studentInfoChange = (student) => {
        setSelectedStudent(student ?? null);
        if (student) {
            filteReference?.current?.setFormValues({
                journeyId: student.journeyId,
                schoolYearId: student.schoolYearId,
            });
        } else {
            filteReference?.current?.setFormValues({
                journeyId: '0',
                schoolYearId: '0',
            });
        }
    };

    const generarReporte = async () => {
        const requiredFields = ['schoolYearId', 'journeyId', 'studentId'];
        for (let field of requiredFields) {
            if (!formData[field] || formData[field] === '0') {
                showMensajeError("Por favor, completa todos los campos obligatorios.");
                return;
            }
        }

        if (!selectedStudent || !selectedStudent.courseId) {
            showMensajeError("El estudiante seleccionado no tiene un curso asociado al año escolar seleccionado.");
            return;
        }

        setShowResult(false);
        setShowLoading(true);
        try {
            const copyData = utils.copy(formData);
            const years = filteReference.current?.getSchoolYears();
            if (years) {
                copyData.year = years.find(p => String(p.schoolYearId) === String(copyData.schoolYearId))?.year ?? "";
            }
            const journeys = filteReference.current?.getJourneys();
            if (journeys) {
                copyData.journey = journeys.find(p => String(p.journeyId) === String(copyData.journeyId))?.name ?? "";
            }
            copyData.studentName = selectedStudent.fullName;
            copyData.grade = selectedStudent.grade;
            setDatosBusqueda(copyData);

            const asistenciasDB = await asistenciaService.getAsistenciasYearReportStudent(formData.schoolYearId, selectedStudent.courseId, formData.studentId);
            // El backend retorna un renglón por fecha/asignatura (asista o no);
            // aquí nos quedamos solo con los renglones donde hubo inasistencia.
            const faltas = (asistenciasDB ?? []).filter(a => Number(a.noAssists ?? 0) > 0);

            if (faltas.length > 0) {
                setAsistencias(faltas);

                const porFechaMap = new Map();
                for (const item of faltas) {
                    const fecha = item.attendanceDate;
                    if (!porFechaMap.has(fecha)) {
                        porFechaMap.set(fecha, { fecha, asignaturas: [], total: 0 });
                    }
                    const registro = porFechaMap.get(fecha);
                    registro.asignaturas.push(item.schoolSubjectName);
                    registro.total += Number(item.noAssists ?? 0);
                }
                setAusenciasPorFecha(Array.from(porFechaMap.values()).sort((a, b) => moment(a.fecha).diff(moment(b.fecha))));

                const porAsignaturaMap = new Map();
                for (const item of faltas) {
                    const asignatura = item.schoolSubjectName;
                    if (!porAsignaturaMap.has(asignatura)) {
                        porAsignaturaMap.set(asignatura, { asignatura, total: 0 });
                    }
                    porAsignaturaMap.get(asignatura).total += Number(item.noAssists ?? 0);
                }
                setAusenciasPorAsignatura(Array.from(porAsignaturaMap.values()).sort((a, b) => b.total - a.total));

                setShowResult(true);
            } else {
                setAsistencias([]);
                setAusenciasPorFecha([]);
                setAusenciasPorAsignatura([]);
                toast.info("El estudiante no registra inasistencias en el año escolar seleccionado.", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
        } catch (error) {
            console.error("Error al obtener las inasistencias del estudiante:", error);
        }
        setShowLoading(false);
    };

    const totalAnual = asistencias.reduce((sum, a) => sum + Number(a.noAssists ?? 0), 0);
    const totalDiasInasistidos = ausenciasPorFecha.length;

    return (
        <>
          <div className="student-table-container p-3 filter-container">
            <h1>Consolidado de asistencias por estudiante</h1>
            <p>Selecciona los filtros para generar el reporte.</p>

                <div className="row">
                <EstudianteFilter
                  callback={updateForm}
                  callbackStudentInfo={studentInfoChange}
                  properties={
                      {
                          className:'col-md-12 mb-12',
                      }
                  }
                  />
                    <JornadaAnioFilter
                                callback={updateForm}
                                ref={filteReference}
                                properties={
                                    {
                                        className:'col-md-2 mb-2',
                                        id:'formReportAnualEstudiante',
                                        filtro:false
                                    }
                                }
                            />
                        <div className="col-md-2 mb-1 margin-top-45">
                                <Button onClick={generarReporte} className="ml-2">Buscar</Button>
                        </div>
                </div>
          </div>
          {showLoading && <Loading />}

          {!showLoading && showResult && (

                    <div className="">
                    <div className="card acta-container">
                        <div className="card-body">

                                {/* Cabezera */}
                                <HeaderActa />
                                {/* Ficha del reporte */}
                                <section className="incidencia-info">
                                <div class="info-header">
                                    <h5 class="section-title">CONSOLIDADO DE INASISTENCIAS ANUAL</h5>
                                </div>
                                <div class="info-body">

                                    <div class="info-item">
                                        <span class="info-title-boletin">Año escolar </span>
                                        <span class="info-content-boletin"> {datosBusqueda.year}</span>
                                    </div>
                                    <div class="info-item">
                                        <span class="info-title-boletin">Jornada </span>
                                        <span class="info-content-boletin"> {datosBusqueda.journey}</span>
                                    </div>
                                    <div class="info-item">
                                        <span class="info-title-boletin">Estudiante </span>
                                        <span class="info-content-boletin"> {datosBusqueda.studentName}</span>
                                    </div>
                                    <div class="info-item">
                                        <span class="info-title-boletin">Grado </span>
                                        <span class="info-content-boletin"> {datosBusqueda.grade}</span>
                                    </div>
                                    <div class="info-item">
                                        <span class="info-title-boletin">Fecha de impresion </span>
                                        <span class="info-content-boletin"> {moment().format('DD-MM-YYYY')}</span>
                                    </div>
                                    <div class="info-item">
                                        <span class="info-title-boletin">Total inasistencias en el año </span>
                                        <span class="info-content-boletin"> {totalAnual}</span>
                                    </div>
                                    <div class="info-item">
                                        <span class="info-title-boletin">Total días inasistidos </span>
                                        <span class="info-content-boletin"> {totalDiasInasistidos}</span>
                                    </div>

                                </div>
                                </section>

                                <section className="incidencia-implicados">
                                        <h5 className="section-title">Inasistencias por fecha</h5>
                                        <table className="tabla-implicados">
                                        <thead>
                                            <tr>
                                                <th>No.</th>
                                                <th>Fecha</th>
                                                <th>Asignatura(s)</th>
                                                <th>Total inasistencias del día</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ausenciasPorFecha?.map((registro, index) => (
                                            <tr key={index}>
                                                <td>{index+1}</td>
                                                <td>{moment(registro.fecha).format('DD-MM-YYYY')}</td>
                                                <td>{registro.asignaturas.join(', ')}</td>
                                                <td>{registro.total}</td>
                                            </tr>
                                            ))}
                                        </tbody>
                                        </table>
                                    </section>

                                <section className="incidencia-implicados">
                                        <h5 className="section-title">Inasistencias por asignatura</h5>
                                        <table className="tabla-implicados">
                                        <thead>
                                            <tr>
                                                <th>No.</th>
                                                <th>Asignatura</th>
                                                <th>Total inasistencias en el año</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ausenciasPorAsignatura?.map((registro, index) => (
                                            <tr key={index}>
                                                <td>{index+1}</td>
                                                <td>{registro.asignatura}</td>
                                                <td>{registro.total}</td>
                                            </tr>
                                            ))}
                                        </tbody>
                                        </table>
                                    </section>

                                <section className="incidencia-implicados">
                                    <h5 className="section-title">Total</h5>
                                    <table className="tabla-implicados">
                                    <thead>
                                        <tr>
                                            <th>Total inasistencias en el año</th>
                                            <th>Total días inasistidos</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{totalAnual}</td>
                                            <td>{totalDiasInasistidos}</td>
                                        </tr>
                                    </tbody>
                                    </table>
                                </section>

                        <FooterActa
                        reportTypeId={types.reportTypes.ASISTENCIA}></FooterActa></div>

                    </div>

                                <br />
                                    <button className="btn btn-primary center display-block" onClick={() => window.print()}>Imprimir</button>
                                <br />
                    </div>

          )}
        </>
    );
  };

  export default RepoAsistenciaAnualEstudiante;
